/** Pure spatial helpers for the SFX bus (unit-tested). World pixels; listener = player feet. */
export interface SpatialOptions {
  /** Full volume within this distance (px). */
  refDistance: number;
  /** Silent beyond this distance (px). */
  maxDistance: number;
  /** Horizontal distance (px) that maps to full pan. */
  panWidth: number;
  /** Never pan harder than this (keeps mono-ish SFX natural). */
  maxPan: number;
}
export const DEFAULT_SPATIAL: SpatialOptions = { refDistance: 96, maxDistance: 480, panWidth: 320, maxPan: 0.8 };

export interface Spatialized { gain: number; pan: number; distance: number }

/** Distance attenuation (smooth quadratic roll-off) + stereo pan from the listener. */
export function spatialize(src: { x: number; y: number }, listener: { x: number; y: number }, o: SpatialOptions = DEFAULT_SPATIAL): Spatialized {
  const dx = src.x - listener.x, dy = src.y - listener.y;
  const distance = Math.hypot(dx, dy);
  let gain = 1;
  if (distance > o.refDistance) {
    const t = Math.min(1, (distance - o.refDistance) / Math.max(1, o.maxDistance - o.refDistance));
    gain = (1 - t) * (1 - t);
  }
  const pan = clamp(dx / o.panWidth, -1, 1) * o.maxPan;
  return { gain, pan, distance };
}

export function clamp(v: number, lo: number, hi: number): number { return v < lo ? lo : v > hi ? hi : v; }
